const baseUrl_MapView = "https://mapview.api-apx.com/Map_api/v2/";
const baseUrl_LeadFinder = "https://leadsfizz.api-apx.com/api/v2/"

export const VerifyAddOn_MapView = baseUrl_MapView + "Verify_Subscription";
export const VerifyAddOn_LeadFinder = baseUrl_LeadFinder + "Verify_Subscription"



